import axios from "axios";

export function createAbortControllerManager() {
    let controller = null;

    return {
        nextSignal() {
            if (controller) {
                controller.abort();
            }
            controller = new AbortController();
            return controller.signal;
        },
        abortActive() {
            if (controller) {
                controller.abort();
                controller = null;
            }
        },
    };
}

export function isRequestCancelled(error) {
    return (
        axios.isCancel?.(error) ||
        error?.name === "CanceledError" ||
        error?.name === "AbortError" ||
        error?.code === "ERR_CANCELED"
    );
}
